import { V004PartitionCharacter } from '../../V004AlgorithmTypes';
import { ProtocolVersion } from '@standardnotes/models';
import { V004Algorithm } from '../../../../Algorithm';
export class GenerateEncryptedProtocolStringUseCase {
    constructor(crypto) {
        this.crypto = crypto;
    }
    execute(plaintext, rawKey, authenticatedData, additionalData) {
        const nonce = this.crypto.generateRandomKey(V004Algorithm.EncryptionNonceLength);
        const ciphertext = this.encryptString(plaintext, rawKey, nonce, authenticatedData);
        const components = [
            ProtocolVersion.V004,
            nonce,
            ciphertext,
            authenticatedData,
            additionalData,
        ];
        return components.join(V004PartitionCharacter);
    }
    encryptString(plaintext, rawKey, nonce, authenticatedData) {
        if (!nonce) {
            throw 'encryptString null nonce';
        }
        if (!rawKey) {
            throw 'encryptString null rawKey';
        }
        return this.crypto.xchacha20Encrypt(plaintext, nonce, rawKey, authenticatedData);
    }
}
